import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeNext", "buttonLabel", "tourKey", "stepKey", "children", "use", "size", "useInStepKey", "navigationCallbackPath", "disableColorRemap"];
import { useContext, useRef } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { TourButtonLabel } from '../constants/styles';
import { hasRedesignGate } from '../utils/redesignGate';
import { usePrimaryButtonStyle } from '../constants/buttonUtils';
import UITourNextButtonLegacy from './UITourNextButton.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderDefaultContent({
  label,
  iconColor
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(TourButtonLabel, {
      children: label !== null && label !== void 0 ? label : I18n.text('shepherd-react.next')
    }), /*#__PURE__*/_jsx(RightIcon, {
      size: "100",
      color: iconColor
    })]
  });
}
const isTourStepMatched = (tourContext, stepKey) => {
  // If stepKey is empty, consider as matched
  if (!stepKey) {
    return true;
  }
  const currentStepKey = tourContext.getStep();
  return currentStepKey === stepKey;
};
const UITourNextButtonModern = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeNext = emptyFunction,
      buttonLabel,
      tourKey,
      stepKey,
      children: childrenProp,
      use: useProp = 'primary-on-fill',
      size = 'small',
      useInStepKey,
      navigationCallbackPath,
      disableColorRemap
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    use,
    iconColor
  } = usePrimaryButtonStyle({
    use: useProp,
    disableColorRemap
  });
  const children = childrenProp !== null && childrenProp !== void 0 ? childrenProp : renderDefaultContent({
    label: buttonLabel,
    iconColor
  });
  const {
    getTour,
    getStep
  } = tour;
  const isHandlingClick = useRef(false);
  const handleClick = event => {
    // Skip click handler if:
    //   1. tour handler is executing
    //   2. Or current tour step are not matched with given props
    if (isHandlingClick.current || !isTourStepMatched(tour, useInStepKey)) {
      return null;
    }
    isHandlingClick.current = true;
    if (props.onClick) {
      props.onClick(event);
    }
    try {
      return handleCallback(beforeNext, () => {
        tour.next(stepKey);
        isHandlingClick.current = false;
        if (navigationCallbackPath && tour.navigationCallback) {
          tour.navigationCallback(navigationCallbackPath);
        }
      }, {
        tourKey: tourKey || getTour(),
        stepKey: stepKey || getStep()
      });
    } catch (error) {
      isHandlingClick.current = false;
      throw error;
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: use,
    size: size
  }, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
const UITourNextButton = props => {
  if (hasRedesignGate()) {
    return /*#__PURE__*/_jsx(UITourNextButtonModern, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(UITourNextButtonLegacy, Object.assign({}, props));
};
export { UITourNextButtonModern };
export default UITourNextButton;